import { useEffect, useState } from "react";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import { ImageFileListContainer } from "../../../style/contents/image/image";
import { useAuthStore } from "../../../atoms/user.auth.store";
import { useLocation, useParams } from "react-router-dom";
import { fetchImageBackupList } from "../../../api/admin";
import UserInfo from "../../../components/backup/user.info";
import SearchForm from "../../../components/common/search.form";
import ImageDriveListTable from "../../../components/backup/image.drive.list.table";

export interface ImageBackupFileItem {
  backupId: number;
  userId: number;
  userName: string;
  userAccount: string;
  fileName: string;
  deviceId: string;
  type: "disk" | string;
  size: number;
  s3Url: string;
  backupStamp: string;
  createdDate: string;
  rootDirectoryPath?: string | null;
}

const decodeBase64Param = (value: string | null) => {
  if (!value) return "";

  try {
    return decodeURIComponent(atob(value));
  } catch {
    return decodeURIComponent(value);
  }
};

const ImageDrive = () => {
  const { role } = useAuthStore();

  const [fileList, setFileList] = useState<ImageBackupFileItem[]>([]);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageSize, setPageSize] = useState("10");
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const { path: rawDeviceId = "" } = useParams<{ path: string }>();
  const deviceId = decodeURIComponent(rawDeviceId);
  const id = queryParams.get("id");
  const userAccount = queryParams.get("userAccount");
  const pcName = decodeBase64Param(queryParams.get("pcName"));
  const rawDirectoryInfo = localStorage.getItem("directory");
  const directoryInfo = rawDirectoryInfo ? JSON.parse(rawDirectoryInfo) : null;
  const adminUserId = localStorage.getItem("userId");
  const filteredFileList = fileList.filter(
    (file) => file.userId === Number(id) && file.deviceId === deviceId,
  );

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    // TODO: fetchData(keyword, pageSize);
  };

  const handlePageSizeChange = (size: string) => {
    setPageSize(size);
  };

  useEffect(() => {
    const loadFileList = async () => {
      if (!deviceId || !id || !adminUserId) return;

      setIsLoading(true);
      try {
        const response = await fetchImageBackupList(adminUserId);
        setFileList(response.backupList || []);
      } catch (err) {
        console.error("파일 목록 조회 실패:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (role === "admin") loadFileList();
  }, [adminUserId, deviceId, id, role]);
  return (
    <ImageFileListContainer>
      <ContentsTopHeader
        title="디바이스 목록  > 드라이브 이미지 백업 목록"
        backArrowPath="-1"
      />
      <div className="contents-top">
        <div className="device-name">
          <p>
            {pcName}({deviceId})
          </p>
        </div>
        <div className="device-info">
          <p>마지막 백업시간 : {directoryInfo?.createDate || "-"}</p>
          {role === "admin" && <UserInfo userAccount={userAccount || ""} />}
        </div>
      </div>
      <div className="file-list-container">
        <div className="top">
          <div className="path-name"></div>
          <div className="right">
            <SearchForm
              onSearch={handleSearch}
              onPageSizeChange={handlePageSizeChange}
              pageSize={pageSize}
            />
          </div>
        </div>
        {filteredFileList ? (
          <ImageDriveListTable
            data={filteredFileList}
            searchKeyword={searchKeyword}
            pageSize={parseInt(pageSize)}
            isLoading={isLoading}
          />
        ) : (
          <div>
            <p>로딩 중입니다.</p>
          </div>
        )}
      </div>
    </ImageFileListContainer>
  );
};

export default ImageDrive;
